import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center text-ink-soft">
        <Loader2 size={22} className="animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/journal/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!user.is_admin) {
    return (
      <div className="max-w-lg mx-auto py-24 px-6 text-center">
        <div className="eyebrow mb-3">Access denied</div>
        <h1 className="font-display text-3xl text-ink mb-4">Not an admin account</h1>
        <p className="text-ink-soft text-[15px] leading-relaxed">
          You're signed in as <span className="num text-ink">{user.email}</span>, but this
          account is not on the Journal editor allowlist. Reach out to Rohan to be added.
        </p>
      </div>
    );
  }

  return children;
}
